import type { ReactElement } from 'react';
import { Box } from '@mantine/core';
import { Activity } from 'lucide-react';
import PageHeaderComponent from '@/design/PageHeaderComponent';
import PageLevelFilterRow from '@/shared/surfaces/PageLevelFilterRow';
import SurfaceAssistScope, { SurfaceAssistToolbar } from '@/shared/surfaces/assist/SurfaceAssistScope';
import { useSurface } from '@/shared/surfaces/useSurface';
import TopicNotFound from '@/shared/surfaces/TopicNotFound';
import GovernanceActivityTab from './GovernanceActivityTab';

/** Governance › Activity: everything done in governance, newest first — issue triage and policy changes. */
export default function GovernanceActivityPage(): ReactElement {
    const surface = useSurface('governance');
    if (surface === undefined) return <TopicNotFound />;

    return (
        <SurfaceAssistScope surface={surface}>
            <Box pb="xl">
                <PageLevelFilterRow inactive inactiveNote="Not applied — the activity feed spans all governance work" assist={<SurfaceAssistToolbar surface={surface} />} />

                <PageHeaderComponent
                    icon={Activity}
                    eyebrow="Governance"
                    title="Activity"
                    subtitle="Everything done in governance, newest first — issue triage (status, resolutions, flags, assignments, notes, uploads) and policy changes."
                />

                <GovernanceActivityTab />
            </Box>
        </SurfaceAssistScope>
    );
}
